"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.features = void 0;
exports.features = {
    singleword_benchmark: {
        name: 'Yes/No/Spoken Digit Benchmark',
        storageKey: 'hideTargetSegmentBanner',
        configFlag: 'BENCHMARK_LIVE',
        taxonomy: 'singlewordBenchmark',
    },
    covid_19_spotter: {
        name: 'Covid-19 Keyword Spotter',
        configFlag: 'COVID19_LIVE',
        taxonomy: 'covid19Spotter',
    },
};
//# sourceMappingURL=feature.js.map